import { render, staticRenderFns } from "./SearchTableau.vue?vue&type=template&id=63e728ba&scoped=true&lang=pug"
import script from "./SearchTableau.vue?vue&type=script&lang=js"
export * from "./SearchTableau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e728ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e728ba')) {
      api.createRecord('63e728ba', component.options)
    } else {
      api.reload('63e728ba', component.options)
    }
    module.hot.accept("./SearchTableau.vue?vue&type=template&id=63e728ba&scoped=true&lang=pug", function () {
      api.rerender('63e728ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SearchTableau.vue"
export default component.exports